import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMiniFridge = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 18,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h16Zm0 1H1v18h16V1Zm-2 1a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm0 1H3v14h12V3ZM7 5v2l.905 4.071c.047.214.077.431.089.65l.006.218V16H5v-4.06a4 4 0 0 1 .054-.654l.041-.215L6 7V5h1Zm6 8v3H9v-3h4ZM6.5 9.36l-.429 1.928a2.997 2.997 0 0 0-.063.433L6 11.939V15h1v-3.06c0-.147-.01-.292-.032-.437l-.04-.215L6.5 9.36ZM12 14h-2v1h2v-1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgMiniFridge;